import { numberUtils } from '@ustra/core'

export default (value, fix = 0): string => {
  if (typeof value !== 'number') {
    return value
  }

  return numberUtils.formatCurrency(value, fix)
}
